import { render, staticRenderFns } from "./patient_card_selectuser.vue?vue&type=template&id=387a153b"
import script from "./patient_card_selectuser.vue?vue&type=script&lang=js"
export * from "./patient_card_selectuser.vue?vue&type=script&lang=js"
import style0 from "./patient_card_selectuser.vue?vue&type=style&index=0&id=387a153b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports